import React,{useState, useEffect} from 'react'
import api from '../../../api/api';
import {useForm} from 'react-hook-form'
import Images from "../../../media/images";
import { toast } from 'react-toastify';



const UpdatePayment = ({paymentId}) => {
    const {register, handleSubmit, unregister, setValue} = useForm();
    const [results, setResults] = useState([])
    const [paymentList, setPaymentList] = useState({})
    const [modify, setModify] = useState(false)



    useEffect(() => {
        
            // alert(paymentId)
            api.get(`/info/payment-details/?id=${paymentId}`)
            .then(response=> {
              // setPaymentList(response.data.filter((item)=>item.id===paymentId)[0])
              setPaymentList(response.data[0])
            }).catch(error=> {
                console.log(error)
            })
        
    }, [paymentId,modify])
    
    const handleSub = (data) => {
      let image=data.image[0]
      const formData=new FormData();
      formData.append("title",data.title);
      formData.append("payment_type",data.payment_type);
      formData.append("name",data.name);
      formData.append("branch_name",data.branch_name);
      formData.append("acholderName",data.acholderName);
      formData.append("acnumber",data.acnumber);
      formData.append("contact_number",data.contact_number);
     
    
      formData.append("image",image);

      api.patch(`/info/payment-details/${paymentId}/`,formData)
      .then(res=> {
        // changes(true)
        setModify(true)
        toast.success("Successfully registered")
        // navigate("/staff/bookmark-list")
  
      }).catch(err=> {
        toast.error("Something went wrong")
      })  

    }

    

  return (
    <div
        className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="UpdatePaymentModalDemo"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
          <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
            <div className="flex justify-end">
              <svg
                data-bs-dismiss="modal"
                aria-label="Close"
                className="text-primary-blue h-8 w-8"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
                />
              </svg>
            </div>
            <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
            
            <div>
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Update Payment
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>

      <form className="px-10" onSubmit={handleSubmit(handleSub)}>
        <div className="grid md:grid-cols-2  grid-cols-1 border-2 border-primary-blue font-bold mt-3">
          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Title</label>
            <input
              type="text"
              name="title"
              placeholder="Title"
              {...register("title", { required: false },setValue("title",paymentList.title))}
            />
          </div>

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Payment Type</label>
            <br />
            <select
              className="text-primary-blue"
              {...register("payment_type", { required: false },setValue("payment_type",paymentList.payment_type))}
            >
              <option>Select</option>
              <option value="BA">Bank</option>
              <option value="PH">Fone Pay</option>
              <option value="ES">E-sewa</option>
              <option value="OT">Other Details</option>
            </select>
          </div>
          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Name</label>
            <br />
            <input
              type="text"
              className="text-primary-blue"
              placeholder="Name"
              {...register("name", { required: false },setValue("name",paymentList.name))}
            />
          </div>

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Branch Name</label>
            <br />
            <input
              type="text"
              className="text-primary-blue"
              placeholder="Branch Name"
              {...register("branch_name", { required: false },setValue("branch_name",paymentList.branch_name))}
            ></input>
          </div>

          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Account Holder Name</label>
            <input
              type="text"
              placeholder="Company Name"
              className="text-primary-blue"
              name="acholderName"
              {...register("acholderName", { required: false },setValue("acholderName",paymentList.acholderName))}

              //   {...register(
              //     "company_name",
              //     { required: false },
              //     // setValue("company_name", results?.company_name ?? "")
              //   )}
              //  defaultValue={results?.company_name ? results.company_name : ''}
            />
          </div>

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Account Number</label>
            <input
              type="text"
              placeholder="Company Address"
              className="text-primary-blue"
              name="acnumber"
              {...register("acnumber", { required: false },setValue("acnumber",paymentList.acnumber))}
            />
          </div>

          {/* <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Contact Number</label>
            <input
              type="text"
              placeholder="Contact Number"
              className="text-primary-blue"
              {...register("acnumber", {required:false})}
            />
          </div> */}

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Contact Number</label>
            <input
              type="text"
              placeholder="Contact Number"
              className="text-primary-blue"
              {...register("contact_number", { required: false },setValue("contact_number",paymentList.contact_number))}
              //   defaultValue={
              //     results?.conatact_number ? results.conatact_number : ""
              //   }
            />
          </div>

          {/* <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Company PAN Number</label>
            <input
              type="text"
              placeholder="Company PAN Number"
              className="text-primary-blue"
            //   {...register("company_pan_vat", { required: false })}
            />
          </div> */}

          <div className="  p-3  border-r border-primary-blue items-center gap-3 text-red-600">
            <img src={paymentList.image} alt="" />
            <label>Image</label>
            <input type="file" {...register("image", { required: false },setValue("image",paymentList.image))} />
          </div>
        </div>

        <button
          type="submit"
          className=" bg-primary-blue text-white text-base p-2 rounded-2xl mt-3"
        >
          Submit
        </button>
      </form>
    </div>
             
            </div>
            
          </div>
        </div>
      </div>
  )
}

export default UpdatePayment